import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { DaySelectorPage } from './day-selector.page';

const routes: Routes = [
  {
    path: '',
    component: DaySelectorPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DaySelectorPageRoutingModule {}
